import { RegisterPage } from '@agentic-flow-studio/shared/components/auth/RegisterPage';
import { SkillViperLogo } from '@agentic-flow-studio/shared/components/skill-viper-logo';
import { authClient } from '@/utils/betterAuth';

export default function Register() {
  return (
    <RegisterPage
      brandName="Skill Viper"
      logo={<SkillViperLogo className="h-7 w-7" />}
      app="skill-viper"
      authClient={authClient}
    />
  );
}
